import { Skeleton } from '@zoopla-eng/zds/skeleton';
import { Box } from '@zoopla-eng/zds/box';
import {
    skeletonCardStyles,
    skeletonTitleStyles,
    skeletonTextWrapperStyles,
    skeletonDetailsStyles,
    skeletonFooterStyles,
    skeletonImagesStyles,
    skeletonPriceStyles,
    skeletonAgentLogoStyles,
    skeletonPOIStyles
} from './ListingCardLandscapeSkeleton.css';

export const ListingCardLandscapeSkeleton = () => {
    return (
        <Box pb="S400" bpM100={{ pb: 'M300' }} data-testid="load-skeleton">
            <div className={skeletonCardStyles}>
                <div className={skeletonDetailsStyles}>
                    <div className={skeletonImagesStyles}>
                        <Skeleton.Root loadingText="Loading">
                            <Skeleton.Wave />
                        </Skeleton.Root>
                    </div>
                    <div className={skeletonTextWrapperStyles}>
                        <div className={skeletonTitleStyles}>
                            <Skeleton.Text />
                        </div>
                        <div className={skeletonPriceStyles}>
                            <Skeleton.Text />
                        </div>
                        <div className={skeletonPOIStyles}>
                            <Skeleton.Wave />
                            <Skeleton.Wave />
                            <Skeleton.Wave />
                        </div>
                    </div>
                </div>
                <div className={skeletonFooterStyles}>
                    <div className={skeletonAgentLogoStyles}>
                        <Skeleton.Wave />
                    </div>
                </div>
            </div>
        </Box>
    );
};
